@if (!loadingData) {
  <div>
    <div class="hidden-print quiz-match-the-pairs-input">
      @for (subQuestion of question.subQuestions; track subQuestion) {
        <div>
          <ebs-match-the-pairs-subquestion [identifier]="subQuestion.id" (notify)='markIncomplete()'
          [showFeedback]='showFeedback' [question]='subQuestion'></ebs-match-the-pairs-subquestion>
          <hr>
          </div>
        }
        <div class="mb-4">
          @if (showFeedback && answerIsCorrect() && question.correctCommentsHtml !=null) {
            <div ebsTechnicalContent class="text-info small"
              [innerContent]="question.correctCommentsHtml">
            </div>
          }
          @if (showFeedback && !answerIsCorrect() && question.incorrectCommentsHtml !=null) {
            <div ebsTechnicalContent class="text-info small"
              [innerContent]="question.incorrectCommentsHtml">
            </div>
          }
          @if (showFeedback && question.neutralCommentsHtml!=null) {
            <div ebsTechnicalContent class="text-info small"
              [innerContent]="question.neutralCommentsHtml">
            </div>
          }
        </div>
      </div>
      <div class="d-none d-print-block table-responsive match-the-pairs">
        <table class="table">
          <tr>
            <td style="width: 50%">
              <ul>
                @for (subQuestion of question.subQuestions; track subQuestion) {
                  <li>{{subQuestion.questionText}}</li>
                }
              </ul>
            </td>
            <td style="width: 50%">
              @if (question?.subQuestions != null && question.subQuestions.length > 0) {
                <ul>
                  @for (option of question.subQuestions[0].options; track option) {
                    <li>{{option.text}}</li>
                  }
                </ul>
              }
            </td>
          </tr>
        </table>
      </div>
    </div>
  }